import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-lock',
  templateUrl: './icon-lock.component.html',
  styleUrl: './icon-lock.component.scss'
})
export class IconLockComponent {
    @Input() isActive: boolean = false;
}
